import React from 'react';
import { Honeybadger } from "@honeybadger-io/react";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
  "Accept-Version": "v1",
  Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_API_KEY}`,
};

const UNSPLASH_BASE_URL = 'https://api.unsplash.com';

export const useUnsplash = () => {
  const fetchImagesByTopic = async (topic: string, count = "1") => {
    try {
      const response = await fetch(`${UNSPLASH_BASE_URL}/photos/random?query=${topic}&count=${count}&orientation=landscape`, {
        method: "GET",
        headers,
      });
      if (response.ok) {
        return {
          success: true,
          data: await response.json()
        };
      }
    } catch (e: any) {
      Honeybadger.notify(e);

      return {
        success: false,
        error: e
      }
    }
  }
  return {
    fetchImagesByTopic,

  }
}